// extracted by mini-css-extract-plugin
module.exports = {"container":"_2NXPxDJWStkq_Jri2uxCB2","newAdditionalDishFields":"_3bcDWBfV20Ll4rBXA_3nJ4"};